// export const getPortfolioFromState = state => state.portfolioSelectedReducer;
export const getPortfolioSetdReducer = state => state.portfolioSetdReducer;
// export const getSubportfolioSetdReducer = state => state.subportfolioSetdReducer;